
export default function TrustBadges() {
  const badges = [
    { icon: 'ri-checkbox-circle-line', text: 'No obligation' },
    { icon: 'ri-percent-line', text: '100% FREE audit' },
    { icon: 'ri-user-star-line', text: 'Expert recommendations' },
    { icon: 'ri-phone-line', text: 'Same-day callback available' }
  ];

  return (
    <div className="flex flex-wrap justify-center items-center gap-8 mt-12">
      {badges.map((badge, index) => (
        <div key={index} className="flex items-center space-x-2">
          <div className="w-6 h-6 bg-green-500 rounded-full flex items-center justify-center">
            <i className={`${badge.icon} text-white text-sm`}></i>
          </div>
          <span className="text-gray-700 font-medium">{badge.text}</span>
        </div>
      ))}
    </div>
  );
}